export interface BidStatus {
  id: BID_STATUS;
  names: Record<string, string>;
}

export enum BID_STATUS {
  New = 0,
  Active = 1,
  InProgress = 2,
  Finished = 3,
  Rejected = 4,
  Canceled = 5,
  Archive = 6
}

export const BID_STATUS_USES :BidStatus [] = [
  {
    id: BID_STATUS.New,
    names: {
      'en-US': 'New',
      'ru-RU': 'Новая',
      'ar-LB': 'جديد',
      'uz-Latn-UZ': 'Yangi',
      'uz-Cyrl-UZ': 'Янги',
      'fr-FR': 'Nouveau'
    }
  },
  {
    id: BID_STATUS.Active,
    names: {
      'en-US': 'Active',
      'ru-RU': 'Активная',
      'ar-LB': 'نشط',
      'uz-Latn-UZ': 'Faol',
      'uz-Cyrl-UZ': 'Фаол',
      'fr-FR': 'Actif'
    }
  },
  {
    id: BID_STATUS.InProgress,
    names: {
      'en-US': 'In progress',
      'ru-RU': 'В работе',
      'ar-LB': 'قيد التنفيذ',
      'uz-Latn-UZ': 'Jarayonda',
      'uz-Cyrl-UZ': 'Жараёнда',
      'fr-FR': 'En cours'
    }
  },
  {
    id: BID_STATUS.Finished,
    names: {
      'en-US': 'Finished',
      'ru-RU': 'Завершена',
      'ar-LB': 'منجز',
      'uz-Latn-UZ': 'Yakunlandi',
      'uz-Cyrl-UZ': 'Якунланди',
      'fr-FR': 'Terminé'
    }
  },
  {
    id: BID_STATUS.Rejected,
    names: {
      'en-US': 'Rejected',
      'ru-RU': 'Отклонена',
      'ar-LB': 'مرفوض',
      'uz-Latn-UZ': 'Rad etildi',
      'uz-Cyrl-UZ': 'Рад этилди',
      'fr-FR': 'Rejeté'
    }
  },
  {
    id: BID_STATUS.Canceled,
    names: {
      'en-US': 'Canceled',
      'ru-RU': 'Отменена',
      'ar-LB': 'ملغى',
      'uz-Latn-UZ': 'Bekor qilingan',
      'uz-Cyrl-UZ': 'Бекор қилинган',
      'fr-FR': 'Annulé'
    }
  },
  {
    id: BID_STATUS.Archive,
    names: {
      "en-US": "Archived",
      "ru-RU": "В Архиве",
      "ar-LB": "مؤرشف",
      "uz-Latn-UZ": "Arxivlangan",
      "uz-Cyrl-UZ": "Архивланган",
      "fr-FR": "Archivé"
    }
  }
];

export const BID_ICON_STATUS: { [key: string]: string } = {
  [BID_STATUS.New]: '',
  [BID_STATUS.Active]: '',
  [BID_STATUS.InProgress]: 'progress',
  [BID_STATUS.Finished]: 'pi-check',
  [BID_STATUS.Rejected]: 'pi-times-circle',
  [BID_STATUS.Canceled]: 'pi-times-circle',
  [BID_STATUS.Archive]: 'pi-check',
};

export const BID_SEVERITY_STATUS: { [key: string]: string } = {
  [BID_STATUS.New]: 'info',
  [BID_STATUS.Active]: 'info',
  [BID_STATUS.InProgress]: 'info',
  [BID_STATUS.Finished]: 'success',
  [BID_STATUS.Rejected]: 'danger',
  [BID_STATUS.Canceled]: 'danger',
  [BID_STATUS.Archive]: 'success',
};
